import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postLinkOrganization } from '../../../api';

export const coreOrganizationsLinkPostAsyncSlice = createPostAsyncSlice({
	name: 'CoreOrganizationsLink',
	receive: true,
	request: true,
	requestHandler: postLinkOrganization
});
